'use strict';
const angular = require('angular');

import {AbstractDomainClassImport} from './AbstractDomainClass';
import {AbstractRelationClassImport} from './AbstractRelationClass';
import {DomainBootstrapperImport, DomainBootstrapperRun} from './DomainBootstrapper';
import {DomainCacheProvider} from './DomainCache';
import {DomainClassHelperImport} from './DomainClassHelper';
import {DomainCollectionProvider} from './DomainCollection';
import {DomainCollectionInstanceProvider} from './DomainCollectionInstance';
import {DomainProvider} from './DomainProvider';
import {DomainUtilitiesImport} from './DomainUtilities';
import {$domainValidationImport} from './DomainValidationService';
import {excludeDomainImport} from './excludeDomain';
import {filterDomainImport} from './filterDomain';
import {filterDomainAsStringImport} from './filterDomainAsString';

module.exports = angular.module('domain', [
  'firebaseMq',
  'AngularFire.util',
  'persistent-cache',
  require('./domain-properties').name,
])
  .factory('AbstractDomainClass', AbstractDomainClassImport)
  .factory('AbstractRelationClass', AbstractRelationClassImport)
  .factory('DomainBootstrapper', DomainBootstrapperImport)
  .run(DomainBootstrapperRun)
  .provider('$domainCache', DomainCacheProvider)
  .factory('DomainClassHelper', DomainClassHelperImport)
  .provider('$$DomainCollection', DomainCollectionProvider)
  .provider('$$DomainCollectionInstance', DomainCollectionInstanceProvider)
  .provider('$domain', DomainProvider)
  .factory('$$DomainUtilities', DomainUtilitiesImport)
  .service('$domainValidation', $domainValidationImport)
  .filter('excludeDomain', excludeDomainImport)
  .filter('filterDomain', filterDomainImport)
  .filter('filterDomainAsString', filterDomainAsStringImport)
;



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/index.js